module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch03"
    }
  }, [_c('b', [_vm._v("Canada")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In the 1940s, the Canadian government advised mothers to begin toilet-training babies at one month old.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Of Canada’s 36 “Fathers of Confederation,” two of them were named John Hamilton Gray.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("One in ten Canadians say they’d support a law that encouraged people in major cities to wear name tags.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("During World War II, German U-boats sank 23 vessels in Canada’s St. Lawrence River.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The United States has invaded Canada twice—once during the American Revolution and once during the War of 1812.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("One of Canada’s founding fathers was an American: William P. Howland of Pawling, New York.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1943, Fred Rose became the only Communist ever elected to the Canadian parliament.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Despite their good-guy image, Canada’s Mounties have been caught spying on people illegally.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba96c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 81
// module chunks = 0